export const groupBy = <T extends object>(items: T[], getter: (item: T) => string): Record<string, T[]> => items.reduce(
  (result, item) => {
    const hash = getter(item);

    return {
      ...result,
      // @ts-ignore
      [hash]: [
        // @ts-ignore
        ...(result[hash] || []),
        item,
      ],
    };
  },
  {}
);
